// extracted by mini-css-extract-plugin
export var DisplayText = "d_n";
export var sizeExtraLarge = "d_s";
export var sizeLarge = "d_r";
export var sizeMedium = "d_q";
export var sizeSmall = "d_p";